export const STATUS = {
    PENDING: '0',
    APPROVED: '1',
    REJECTED: '2',
    CANCELLED: '3',
    SENT: '4',
    DONE: '5',
}

export const ROLES = {
    INDIVIDUAL: 'INDIVIDUAL',
    BUSINESS: 'BUSINESS',
    LIQUIDITY_PROVIDER: 'LIQUIDITY_PROVIDER',
    ADMIN: 'ADMIN',
    VALIDATOR: 'VALIDATOR',
}
